import { render, staticRenderFns } from "./SmsSent.vue?vue&type=template&id=57b96073&scoped=true&"
import script from "./SmsSent.vue?vue&type=script&lang=js&"
export * from "./SmsSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b96073",
  null
  
)

export default component.exports